import { DIMENSIONI, DOMANDE } from "@/data/simulatorQuestions";
import { ARCHETIPI, COPPIE, NARRATIVA } from "@/data/simulatorArchetypes";

export const TRAITS = DIMENSIONI.map(({ sigla, nome }) => ({ key: sigla, label: nome }));

export const QUESTIONS = DOMANDE.map(({ domanda, risposte }) => ({
  text: domanda,
  answers: risposte.map(({ testo, punti }) => ({ label: testo, pts: punti })),
}));

const shuffle = (arr) => {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
};

export const newOrders = () => QUESTIONS.map((q) => shuffle(q.answers.map((_, i) => i)));

const zero = () => Object.fromEntries(TRAITS.map(({ key }) => [key, 0]));

export const computeResult = (answers) => {
  const raw = zero();
  const max = zero();
  QUESTIONS.forEach((q, i) => {
    TRAITS.forEach(({ key }) => {
      max[key] += Math.max(...q.answers.map((a) => a.pts[key] || 0));
    });
    Object.entries(q.answers[answers[i]].pts).forEach(([k, v]) => {
      raw[k] += v;
    });
  });
  const scores = TRAITS.map((t, i) => ({ ...t, i, value: max[t.key] ? Math.round((raw[t.key] / max[t.key]) * 100) : 0 }));
  const lo = Math.min(...scores.map((s) => s.value));
  const span = Math.max(1, Math.max(...scores.map((s) => s.value)) - lo);
  scores.forEach((s) => {
    s.display = Math.round(40 + (60 * (s.value - lo)) / span);
  });
  const ranked = [...scores].sort((a, b) => b.value - a.value || a.i - b.i);
  const [first, second] = ranked;
  const last = ranked[ranked.length - 1];
  const pair = [first, second].sort((a, b) => a.i - b.i).map((s) => s.key).join("");
  const archetype = ARCHETIPI[COPPIE[pair]];
  const narrative = [NARRATIVA.apertura, archetype.racconto, NARRATIVA.chiusura]
    .join(" ")
    .replace("{prima}", first.label)
    .replace("{seconda}", second.label)
    .replace("{ultima}", last.label);
  return { scores, first, second, last, archetype, narrative };
};
